import type { Project } from "../../types/database";
import StatusDot from "./StatusDot";
import MomentumChip from "./MomentumChip";
import Sparkline, { fakeSparkline } from "./Sparkline";
import { useCockpit } from "../../lib/state";
import { projectGradientCss } from "../../lib/projectColor";

interface ProjectRowProps {
  project: Project;
  hasActiveRun?: boolean;
}

export default function ProjectRow({ project, hasActiveRun }: ProjectRowProps) {
  const selectedId = useCockpit((s) => s.selectedProjectId);
  const setSelected = useCockpit((s) => s.setSelectedProjectId);
  const isSelected = selectedId === project.id;
  const open = project.open_approval_count ?? 0;
  const data = fakeSparkline(project.id, 7);

  return (
    <button
      type="button"
      onClick={() => {
        setSelected(project.id);
        window.location.hash = `#/${project.id}`;
      }}
      className={`aero-glass aero-glass-tight group relative flex w-full items-center gap-2 px-3 py-2 text-left transition-all ${
        isSelected ? "aero-glass-selected" : "hover:aero-glass-strong"
      }`}
      style={{ borderRadius: 16 }}
    >
      <StatusDot health={project.health} active={hasActiveRun} size={9} />
      <span
        className="flex-1 truncate"
        style={{
          fontFamily: "Fraunces, serif",
          fontStyle: "italic",
          fontWeight: 600,
          fontSize: 14,
          color: isSelected ? "white" : "var(--ink)",
          textShadow: isSelected ? "0 1px 2px rgba(120,12,80,.4)" : undefined,
        }}
      >
        {project.name}
      </span>
      <Sparkline
        data={data}
        width={42}
        height={14}
        stroke={
          project.health === "red"
            ? "#cf6679"
            : project.health === "yellow"
              ? "#d4a04c"
              : "#FF1FA5"
        }
        className="pink-glow"
      />
      <span className="w-14 shrink-0 text-right">
        <MomentumChip label={project.momentum_label} />
      </span>
      {open > 0 ? (
        <span
          className="glossy-project-pill"
          style={{
            background: projectGradientCss(project.name, 135),
            fontSize: 8,
            padding: "2px 7px",
          }}
          title={`${open} approvals open`}
        >
          {open}
        </span>
      ) : null}
    </button>
  );
}
